import styled from '@emotion/styled';
import { IconButton } from '@/components/@IntranetLibrary/GNB/styles';

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: white;
  padding: 0.5rem 0 0.5rem 0;
`;

const StyledTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
`;

const StyledButton = styled.button`
  &:hover {
    text-decoration-line: underline;
  }
`;

const AlarmIconButton = styled(IconButton)`
  position: relative;
  transition: all 0.2s ease-in-out;
  &.new {
    > svg {
      animation-name: alarm-shake;
      animation-duration: 1.5s;
      animation-delay: 0.3s;
      animation-iteration-count: infinite;
      animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);
    }
    &[data-count]:not([data-count='0'])::after {
      content: attr(data-count);
      position: absolute;
      top: -3px;
      left: 50%;
      min-width: 18px;
      height: 18px;
      padding: 0 4px;
      border: 1px solid white;
      border-radius: 52px;
      background-color: #f55060;
      text-align: center;
      line-height: 17px;
      font-weight: 700;
      font-size: 12px;
      color: white;
      z-index: 1;
      box-sizing: border-box;
    }
  }
`;

const ContentWrapper = styled.div<{ mobileMode?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  overflow-y: scroll;
  max-height: ${({ mobileMode }) => (mobileMode ? '60vh' : '80vh')};
`;

const Layout = styled.div`
  padding: 1rem;
  width: 27rem;
  min-width: 300px;
  font-family: var(--font-Pretendard);
`;

const StyledNodata = styled.div`
  display: flex;
  width: 100%;
  height: 75vh;
  align-items: center;
  justify-content: center;
`;

export {
  StyledHeader,
  StyledTitle,
  StyledButton,
  ContentWrapper,
  Layout,
  StyledNodata,
  AlarmIconButton,
};
